module.exports = __webpack_public_path__ + "img/ico-location.088013c9.svg";